<template>
  <div class="county">
    <div id="company-recruit">
      <div class="to-sign" @click="dialogVisbility=true">火速报名</div>
    </div>
    <CountyProfile />
    <Market />
    <Support />
    <Conditions />
    <Contact @change="showForm"/>
    <countyForm :dialogVisbility.sync="dialogVisbility" />
    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
import CountyProfile from "./components/countyProfile";
import Market from "./components/market";
import Support from "./components/support";
import Conditions from "./components/conditions";
import Contact from "./components/contact";
import countyForm from "./components/countyForm";
export default {
  name: "county",
  components: {
    HomeFooter,
    Market,
    CountyProfile,
    Support,
    Contact,
    Conditions,
    countyForm
  },
  data() {
    return {
      dialogVisbility: false
    }
  },
  methods: {
    showForm() {
      this.dialogVisbility = true;
    }
  }
}
</script>

<style lang="scss" scoped>
#company-recruit {
  background: url(~@/assets/images/new-img/company/recruit.png) no-repeat center
    top;
  height: 400px;
  position: relative;
  .to-sign {
    width: 193px;
    height: 50px;
    background: #f99b3a;
    border-radius: 25px;
    color: white;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 65px;
    left: 50%;
    margin-left: -96.5px;
    cursor: pointer;
  }
}
</style>
